<template lang="pug">
v-form.mt-8(@submit.prevent)

  v-row(v-if="fields.length")
    v-col.pb-0(
      v-for="(field,index) in fields"
      :key="`widget-${index}`"
      :md="fieldExtent(field)"
    )
      widget(
        ref="widget"
        :field="field"
        :value="getValue(field)"
        readonly
      )

  //- div.pr-4.mt-4(v-if="actions.length")
  //-   widget-link.mr-2(
  //-     v-for="(action,index) in actions"
  //-     :key="`action-${index}`"
  //-     :action="action"
  //-     @click="perform(action)"
  //-   )

  //-   v-btn(@click="clearForm()")
  //-     v-icon(left) mdi-brush
  //-     | Limpar

</template>

<script>
// import { findRels } from '@/helpers/rels'

import Widget from '@/components/widgets/Widget'
import WidgetLink from '@/components/widgets/WidgetLink'
import ActionDialogPopup from '@/components/commons/action-dialog/ActionDialogPopup'

export default {
  components: {
    Widget,
    WidgetLink,
    ActionDialogPopup,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    /** @type {Keep.Paper.Design.Set} */
    set: Object,
    /** @type {Keep.Paper.Design.Row} */
    row: Object,
  },

  data: () => ({
    request: null, // Um link do tipo {Keep.Paper.Design.Link}.
  }),

  computed: {

    fields () {
      const headers = (this.set.headers || [])
      const fields = headers.filter(header =>
        !header.hidden &&
        !header.name.startsWith('@') &&
        !header.name.startsWith('.')
      )
      return fields
    },

    // links: vm => vm.edit.links || [],
    // actions: vm => findRels(vm.links, 'Action'),
  },

  methods: {
    fieldExtent: field => field.extent || 4,

    perform (action) {
      // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      try {
        const ok = this.$refs.form.validate()
        if (!ok)
          return

        const form = {}
        this.fields.forEach(field => form[field.name] = field.value)

        // TODO: Falta coletar o dado do DataSet do form...
        const data = []

        this.request = { ...action, form, data }

      } catch (error) {
        this.request = null
        throw error
      }
    },

    getValue(field) {
      const cell = this.row[field.name]
      return typeof cell === 'object' ? cell.value : cell
    }
  },
}
</script>
